<template>
  <div class="app">
    <CommonHeader></CommonHeader>
    <router-view />
    <Contact></Contact>
    <CommonFooter></CommonFooter>
  </div>
</template>
<script>
import CommonHeader from './components/header.vue';
import CommonFooter from './components/footer.vue';
import Contact from './components/contact.vue';
export default {
  name: 'App',
  components: {
    CommonHeader,
    CommonFooter,
    Contact
  },
  mounted() {
  }
}
</script>